// Mail model types - converted from Go backend models

import type { MailID, UserID } from '@/models/ids';
import type {RFC3339, Timestamps} from '@/models/base-types';

export const MailStatus = {
    WAITING: 'WAITING',
    SENDING: 'SENDING',
    SUCCESS: 'SUCCESS',
    FAILED: 'FAILED'
} as const;

export type MailStatus = typeof MailStatus[keyof typeof MailStatus];

export const MailTemplate = {
    TEST: 'TEST',
    PASSWORD_RESET: 'PASSWORD_RESET',
    COURSE_MAIL_SEQUENCE: 'COURSE_MAIL_SEQUENCE',
    VIDEO_PUBLISHED: 'VIDEO_PUBLISHED',
    RECOMMENDATION: 'RECOMMENDATION',
    RECOMMENDATION_ADJUSTMENT: 'RECOMMENDATION_ADJUSTMENT',
    RECOMMENDATION_FINISHED: 'RECOMMENDATION_FINISHED',
    REGISTER_TOKEN: 'REGISTER_TOKEN',
    EVENT_REMINDER: 'EVENT_REMINDER'
} as const;

export type MailTemplate = typeof MailTemplate[keyof typeof MailTemplate];

export const ALL_MAIL_TEMPLATES: MailTemplate[] = Object.values(MailTemplate);

export const MAIL_TEMPLATE_LABELS: Record<MailTemplate, string> = {
    TEST: 'Testmail',
    PASSWORD_RESET: 'Passwort zurücksetzen',
    COURSE_MAIL_SEQUENCE: 'Kurs E-Mail-Sequenz',
    VIDEO_PUBLISHED: 'Neues Video',
    RECOMMENDATION: 'Tradingidee',
    RECOMMENDATION_ADJUSTMENT: 'Tradingidee-Anpassung',
    RECOMMENDATION_FINISHED: 'Tradingidee beendet',
    REGISTER_TOKEN: 'Registrierungscode',
    EVENT_REMINDER: 'Event-Erinnerung'
};

export const ALL_MAIL_STATUSES: MailStatus[] = Object.values(MailStatus);

export interface Mail extends Timestamps {
    id: MailID;

    receiverEmail: string;

    subject: string;
    body: string;
    mimeType: string;

    template: MailTemplate;

    status: MailStatus;
    retryCount: number;
    maxRetries: number;
    nextRetryAt: RFC3339 | null;

    lastError: string | null;
    sentAt: RFC3339 | null;

    userID: UserID | null; // Optional: Track which user this mail is for

    created: RFC3339;
    updated: RFC3339 | null;
    deleted: RFC3339 | null;
}

// List request/response types
export interface ListMailsOptions {
    status?: MailStatus;
    receiver?: string;
    template?: MailTemplate;
    userID?: UserID;
    since?: RFC3339;
    until?: RFC3339;
    next?: string;
    limit?: number;
    sort?: string;
    sortDirection?: 'ASC' | 'DESC';
    minPriority?: number;
    maxRetries?: number;
}

export interface ListMailsResponse {
    mails: Mail[];
    next: string;
    total: number;
}

// Stats response
export interface MailQueueStats {
    waiting: number;
    sending: number;
    success: number;
    failed: number;
}

// Request bodies
export interface SetMailToFailedRequest {
    reason: string;
}

export interface SendTestMailRequest {
    receiverEmail: string;
    receiverName?: string;
}